import logger from "@/services/Logger";
import store from "@/store";
import Track from "../components/track";

export default {
  name: "track",
  install(ctx) {
    const create = function(track) {
      if (!track) {
        console.error("Current Track required");
        return;
      }

      return new Track({
        track,
        onload: () => {
          logger.log("PLAYER", `LOADED, TRACK: ${this.currentTrack.name}`);
          if (!this.paused) {
            this.currentTrack.play();
          }
        },
        onplay: () => {
          logger.log("PLAYER", `PLAYING, TRACK: ${this.currentTrack.name}`);
          this.mod.core.tick();
        },
        onend: () => {
          logger.log("PLAYER", `ENDED, TRACK: ${this.currentTrack.name}`);
          this.mod.playback.next();
          this.mod.state.save({ running: true });
        },
        onpause: () => {
          logger.log("PLAYER", `PAUSED, TRACK: ${this.currentTrack.name}`);
        },
        onlistened: () => {
          store.dispatch("tracks/listened", this.currentTrackId);
        }
      });
    }.bind(ctx);

    return {
      create
    };
  }
};
